import { useState } from "react";
import { useTranslation } from "next-i18next";

import { Modal } from "common/ui/Modal";
import { Paragraph } from "common/ui/Paragraph";

import { deleteProperty } from "common/middleware/api.properties";

interface Props {
  close: () => void,
  propertyId: number,
  closeOnSuccess: () => void,
}

export function DeleteListingModal({
  close,
  propertyId,
  closeOnSuccess,
}: Props) {
  const { t } = useTranslation("admin");

  const [error, setError] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteListing = async () => {
    if (isDeleting) return;

    setIsDeleting(true);

    try {
      const res = await deleteProperty(propertyId);

      if (res.isFailDueToExistingOffer) {
        setError("deleteListingModal.existingOffer");
        setIsDeleting(false);
        return;
      }

      closeOnSuccess();
    } catch (err) {
      setError(t("common.somethingWentWrong"));
      setIsDeleting(false);
    }
  };

  return (
    <Modal
      title={t("deleteListingModal.confirmDeletion")}
      close={close}
      isProcessing={isDeleting}
      primaryAction={{
        text: t("common.delete"),
        onClick: deleteListing,
        type: "destructive"
      }}
      secondaryAction={{ text: t("common.cancel"), onClick: close }}
      error={error}
    >
      <Paragraph variant="p1">
        {t("deleteListingModal.confirmDelete")}
        {" "}
        <b>{t("deleteListingModal.cannotBeUndone")}</b>
      </Paragraph>
    </Modal>
  )
}
